export default __webpack_public_path__ + "logo_avatar.272bd37d.svg";